import { rhythmCanvasLogic } from './rhythm_canvas.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import {
  RhythmCanvasHost,
  RhythmCanvasProjector,
  RhythmCanvasStudent,
} from '../eval-blocks/MusicNativeViews';

export const rhythmCanvasPlugin: ActivityPlugin<'rhythm_canvas'> = {
  ...rhythmCanvasLogic,
  displayName: GAME_MODE_CATALOG.rhythm_canvas.displayName,
  icon: GAME_MODE_CATALOG.rhythm_canvas.icon,
  HostView: RhythmCanvasHost,
  StudentView: RhythmCanvasStudent,
  ProjectorView: RhythmCanvasProjector,
};

export { demoRhythmCanvasPayload } from './rhythm_canvas.logic';
